import { Outlet, Navigate } from "react-router-dom";
import useUserStore from "../stores/userStore";

const ProtectedLayout = () => {
  const { isAuthenticated, hasHydrated } = useUserStore();

  // Show loading state until hydration is complete
  if (!hasHydrated) {
    return <div>Loading...</div>;
  }

  // If not authenticated after hydration, redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div>
      <Outlet />
    </div>
  );
};

export default ProtectedLayout;
